import { PageHeader, Panel } from '../ds/index'
import { useApi } from '../lib/useApi'
import { LoadingBlock, ErrorBlock } from '../components/Loading'

/**
 * Keeping lead data safe: who sees what, how it is protected, what is kept
 * and for how long, and the incident plan. The same page as
 * docs/DATA-SAFETY.md in the code, so the two never disagree.
 */
export default function DataSafety() {
  const d = useApi<{ text: string }>('/api/data-safety')
  if (d.error) return <ErrorBlock error={d.error} />
  if (!d.data) return <LoadingBlock />
  const blocks = d.data.text.split(/\n{2,}/).map((b) => b.trim()).filter(Boolean)
  const title = blocks[0].replace(/^# /, '')
  return (
    <>
      <PageHeader title={title} subtitle={blocks[1]} />
      <Panel>
        <div className="terms-text data-safety">
          {blocks.slice(2).map((b, i) => b.startsWith('# ') ? <h3 key={i}>{b.slice(2)}</h3>
            : b.startsWith('- ') ? <ul key={i}>{b.split(/\n(?=- )/).map((li, j) => <li key={j}>{li.replace(/^- /, '')}</li>)}</ul>
              : <p key={i}>{b}</p>)}
        </div>
      </Panel>
    </>
  )
}
